export const BuildingsPage = () => {
  return <div>Buildings page</div>;
};
